export class Quiz {
  public _id: string;
  public ordinal: number;
  public quizName_fi: string;
  public quizName_sv: string;
  public quizName_en: string;
  public joinToken: string;
  /*public questionArray: {
    questionID: string
  }[];*/
  public questionArray: string[];
  public useCode: boolean;
}



// WEBPACK FOOTER //
// ./src/app/quiz.ts